import React from "react";
import {Query} from "react-apollo";
import {fromJS} from "immutable";
import PanelGroupController from "../../components/PanelGroupController";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {ORDER_TAGGING_RULE} from "../../queries/shipping";

const properties = fromJS([
  {prop: "title", label: "Title", type: "string"},
  {prop: "ruleId", label: "Id", type: "id"},
  {prop: "status", label: "Status", type: "string"},
  {prop: "accountId", label: "Account", type: "accountId"},
  {prop: "customerName", label: "Account Holder", type: "string"},
  {prop: "orderTypes", label: "Order Types", type: "array"},
  {prop: "skuPattern", label: "SKU Pattern", type: "string"},
  {prop: "tags", label: "Tags", type: "array"},
  {prop: "insertedAt", label: "Created", type: "utc"},
  {prop: "updatedAt", label: "Updated", type: "utc"},
]);

const OrderTaggingRulePropertiesPanel = (props) => {

  let elements = null;
  if (!props.ruleId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    elements = (
      <Query query={ORDER_TAGGING_RULE} variables={{ruleId: props.ruleId}} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading && !(data && data.shippingOrderTaggingRule)) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return <PropertiesList properties={properties} data={fromJS(data.shippingOrderTaggingRule)} />
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Order Tagging Rule" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )
}

export default OrderTaggingRulePropertiesPanel;
